import { gql } from '@apollo/client/core'

export const CANCEL_MEMBERSHIP_MUTATION = gql`
  mutation cancelMembershipBase($input: CancelMembershipInput!) {
    cancelMembership(input: $input) {
      ... on CancelMembershipOutput {
        success
      }
    }
  }
`
